var chunkMapping = {
	"1500": [
		1500
	],
	"1551": [
		98
	],
	"1757": [
		1757
	],
	"2953": [
		4728,
		5745
	],
	"3140": [
		3140
	],
	"4607": [
		4607
	],
	"4787": [
		4787
	],
	"6183": [
		8564
	],
	"6871": [
		6871
	],
	"7124": [
		7124
	],
	"7733": [
		7733
	],
	"8341": [
		8341
	],
	"8548": [
		8548
	],
	"8699": [
		8699
	],
	"9031": [
		9031
	],
	"9637": [
		9637
	]
};
var idToExternalAndNameMapping = {
	"98": [
		"default",
		"./helper",
		9279
	],
	"1500": [
		"default",
		"./EmailPreferences",
		9279
	],
	"1757": [
		"default",
		"./DevBusTOI",
		9279
	],
	"3140": [
		"default",
		"./Industry",
		9279
	],
	"4607": [
		"default",
		"./Organization",
		9279
	],
	"4728": [
		"default",
		"./index",
		4844
	],
	"4787": [
		"default",
		"./Location",
		9279
	],
	"5745": [
		"default",
		"./privacy-portal-menu",
		4844
	],
	"6871": [
		"default",
		"./PreferredLanguage",
		9279
	],
	"7124": [
		"default",
		"./ProfileName",
		9279
	],
	"7733": [
		"default",
		"./InterestBasedAds",
		9279
	],
	"8341": [
		"default",
		"./Unsubscribe",
		9279
	],
	"8548": [
		"default",
		"./UnsubscribeFeedback",
		9279
	],
	"8564": [
		"default",
		"./DeleteData",
		9279
	],
	"8699": [
		"default",
		"./JobRole",
		9279
	],
	"9031": [
		"default",
		"./GamingTOI",
		9279
	],
	"9637": [
		"default",
		"./RequestData",
		9279
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}